import { HttpClient, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ErrorService } from '@cosmos/angular/utils';
import { DocumentTemplate } from '@cosmos/shared';
import { catchError, map, Observable } from 'rxjs';
import { environment } from '../../../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DocumentTemplatesService {

  constructor(
    private http: HttpClient,
    private errorService: ErrorService,
  ) { }

  find(query=''): Observable<HttpResponse<DocumentTemplate[]>> {
    return this.http
      .get<DocumentTemplate[]>(`${environment.API_URL}/document-template${query}`, {observe: 'response'})
        .pipe(
          map(response => {
          return response;
        }),
        catchError( (error) =>{this.errorService.handleError(error); throw error;})
      );
  }

  findById(id: string, query=''): Observable<HttpResponse<DocumentTemplate>> {
    return this.http
      .get<DocumentTemplate>(`${environment.API_URL}/document-template/${id}${query}`, {observe: 'response'})
        .pipe(
          map(response => {return response;}),
          catchError( (error) =>{this.errorService.handleError(error); throw error;})
        );
  }

  create(body: DocumentTemplate) {
    return this.http
      .post(`${environment.API_URL}/document-template`, body, {observe: 'response'})
        .pipe(
          map(response => {return response;}),
          catchError( (error) =>{this.errorService.handleError(error); throw error;})
        );
  }

  update(body: any) {
    return this.http
      .patch(`${environment.API_URL}/document-template/${body[0]}`, body[1], {observe: 'response'})
        .pipe(
          map(response => {return response;}),
          catchError( (error) =>{this.errorService.handleError(error); throw error;})
        )
  }

  delete(id: string) {
    return this.http
      .delete(`${environment.API_URL}/document-template/${id}`, {observe: 'response'})
        .pipe(
          map(response => {return response;}),
          catchError( (error) =>{this.errorService.handleError(error); throw error;})
        );
  }

  testTemplate(id: string, testId: string) {
    return this.http
      .get(`${environment.API_URL}/document-template/${id}/${testId}`, {responseType :'blob', observe: 'response'})
        .pipe(
          map(response => {return response;}),
          catchError( (error) =>{this.errorService.handleError(error); throw error;})
        );
  }

  getContextRegistry(): Observable<HttpResponse<any>> {
    return this.http
      .get<any>(`${environment.API_URL}/document-template/context-registry`, {observe: 'response'})
        .pipe(
          map(response => response),
          catchError((error) => { this.errorService.handleError(error); throw error; })
        );
  }

  previewTemplate(id: string, body: { contextType: string; contextRecordId: string; draftTemplateJson?: object }): Observable<HttpResponse<Blob>> {
    return this.http
      .post(`${environment.API_URL}/document-template/${id}/preview`, body, {responseType: 'blob', observe: 'response'})
        .pipe(
          map(response => response),
          catchError((error) => { this.errorService.handleError(error); throw error; })
        );
  }
}
